import store from '@/store'

export default async (to, from, next) => {
    if (!store.getters['auth/check'] && store.getters['auth/token']) {
        try {
            // await store.dispatch('auth/getUser');
            await store.dispatch("auth/firebaseState", false);
        } catch (e) {
            next({ name: 'province' });
        }
    } else {
        if (!store.getters['auth/user']) {
            // await store.dispatch('auth/getUser');
            await store.dispatch("auth/firebaseState", false);
        }
    }

    next()
}